import { useAppSelector } from "../../store/store";
import { RequestApi, RouteApi, StatusMsg } from "utils";
import { useEffect } from "react";
import { AppLog } from "services";
import Explore from "./explore/Explore";

const IndexPage = () => {
  const { token, userAuth } = useAppSelector((state) => state.auth);

  const initHomeAccount = async () => {
    try {
      let url: string = "";

      url = RouteApi.getHomeAccount;
      url = userAuth ? RouteApi.getHomeAccount : "";
      url += `token=${token}`;

      const response = await RequestApi(url);
      if (response.status === "success") {
        localStorage.setItem("item_groups", JSON.stringify(response["item_groups"]));
        localStorage.setItem("user", JSON.stringify(response["user"]));
      } else {
        AppLog.show({ message: response.msg, status: StatusMsg.getType(response.status) });
      }
    } catch (error) {
      AppLog.show({
        message: `[initHomeAccount]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  useEffect(() => {
    initHomeAccount();
  }, []);

  return <Explore />;
};

export default IndexPage;
